// @ts-nocheck
import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import SinapTheme from "../styles/SinapTheme";



export default function CircularIndeterminate({...props}) {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={SinapTheme} >
            <Box sx={{ textAlign : 'center' , }}>
              <CircularProgress color="primary" {...props} />
            </Box>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}